import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

class PostamatPointsList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({ value, row }) => <Link to={paths.postamatPointsShow(row.original.id)}>{value}</Link>,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "Код",
                accessor: "code",
                filterable: true,
            },
            {
                Header: "Тип",
                accessor: "brand",
                filterable: true,
            },
            {
                Header: "Расписание",
                accessor: "schedule",
                filterable: true,
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(PostamatPointsList, "postamat-points");
